class Home {
  constructor() {
    this.slider()
    this.mosaClick();
    this.mosaDate();
    this.mosaSubstitution();
    //this.mosaNewsletterConnect();
  }

  slider() {
    let mySlider = $('#block-carousel > div.field--name-field-article')
    mySlider.on('init afterChange', function (event, slick, currentSlide) {
      let myNextSlideImg;
      let myPrevSlideImg;
      let prev = 1;
      let next = 1;
      if (currentSlide === 0 || typeof currentSlide === 'undefined') {
        prev = slick.slideCount - 1;
        next = 1;
      } else if (currentSlide === slick.slideCount - 1) {
        prev = currentSlide - 1;
        next = 0;
      } else {
        prev = currentSlide - 1;
        next = currentSlide + 1;
      }
      myNextSlideImg = $('#block-carousel').find(`[data-slick-index='${next}'] article`).data('img')
      myPrevSlideImg = $('#block-carousel').find(`[data-slick-index='${prev}'] article`).data('img')
      $('#block-carousel .slick-prev').html(`<span style="background-image: url('${myPrevSlideImg}')"></span>`)
      $('#block-carousel .slick-next').html(`<span style="background-image: url('${myNextSlideImg}')"></span>`)
    })

    mySlider.slick({
      infinite: true,
      fade: true,
      dots: true,
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 1000,
      pauseOnFocus: false,
      pauseOnHover: false
    })
    // Fix 100% height size on safari mobile
    $(window).on('load resize', function () {
      //let isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
      //if(isSafari && $(window).width() <= 1024){
      $(mySlider).find('.slick-slide article').height($(window).height());
      //}
    });
  }

  mosaClick() {
    let mosaique = document.querySelectorAll('.bloc-infos:not(.no-click)')
    Array.prototype.forEach.call(mosaique, function (element) {
      element.addEventListener('click', function () {
        element.querySelector('a').click()
      })
    })
    $('#block-views-newsletters-block-derniere-nl').click(function () {
      $(this).find('.last-nl').get(0).click();
    });
  }

  mosaDate() {
    let date = new Date;
    let moi = date.getMonth();
    let mois = new Array('Janvier', 'F&eacute;vrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Ao&ucirc;t', 'Septembre', 'Octobre', 'Novembre', 'D&eacute;cembre');
    let j = date.getDate().toString();
    if (j.length == 1) {
      j = '0' + j;
    }
    let jour = date.getDay();
    let jours = new Array('Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi');

    var resultat = '<span class="day">' + jours[jour] + '</span> <span class="date">' + j + '</span> <span class="month">' + mois[moi] + '</span>';
    if ($('.block-substitution.date').length) {
      $('.block-substitution.date>.bloc-infos').html(resultat);
    }
  }

  mosaSubstitution() {
    if ($('#block-views-newsletters-block-derniere-nl').length) {
      $('.block-substitution.date').addClass('hide');
    }
    if ($('#block-newsletterblock').length) {
      $('.block-substitution.family').addClass('hide');
    }
    if ($('#block-sondages').length) {
      $('.block-substitution.kid').addClass('hide');
    }
  }

  mosaNewsletterConnect() {
    if ($('.user-logged-in').length) {
      const elemParent = $('#block-newsletterblock').parent().parent();
      if (!elemParent.hasClass('layout-content')) {
        $('#block-newsletterblock').removeAttr('id').parent().attr('id', 'block-newsletterblock')
      }
    }
  }
}

export default Home
